import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

const STORAGE_KEY = 'paacap_settings';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  private settingsSubject = new BehaviorSubject<any>(null);
  public settings$: Observable<any> = this.settingsSubject.asObservable();

  constructor() {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) this.settingsSubject.next(JSON.parse(stored));
    } catch { }
  }

  setSettings(settings: any[]): void {
    const map: any = {};
  
    for (const item of settings) {
      map[item.code] = item.value;
    }
  
    this.settingsSubject.next(map);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  }

  getSettings(): any {
    return this.settingsSubject.value;
  }

  get<T = any>(key: string, fallback?: T): T {
    const settings = this.settingsSubject.value;
    return settings?.[key] ?? fallback;
  }

  getInitialOtpDuration(): number {
    const settings = this.getSettings();
    return settings?.PAACAP_OTP_LOGIN_REQUEST_DURATION || 300;
  }

  getResendOtpDuration(): number {
    const settings = this.getSettings();
    return settings?.PAACAP_OTP_RESEND_REQUEST_DURATION || 300;
  }

  hasStoredSettings(): boolean {
    return this.getSettings() !== null;
  }
}